/**
 * 客户端 UUID（幂等键 / 主键）。优先使用原生 crypto.randomUUID，失败时降级为模拟 UUID。
 * 阶段 1 仅用于本地内存中的演示对象；阶段 2 起由 Dexie 仓储统一调用。
 */
export function uuid(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
